var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlusLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6 .3a.9.9 0 0 1 .9.895V5.1h3.905c.456 0 .833.34.888.786L11.7 6a.9.9 0 0 1-.895.9H6.9v3.905c0 .456-.34.833-.786.888L6 11.7a.9.9 0 0 1-.9-.895V6.9H1.195a.9.9 0 0 1 0-1.8H5.1V1.195c0-.456.34-.833.786-.888z"
})));
export default SvgIconPlusLarge;